// extracted by mini-css-extract-plugin
export default {"fixedContainer":"SinglePageLayout_fixedContainer__mg67y"};